"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Running(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M8.941 14.398L8.379 15H3.5v2h5.744l1.156-1.233-1.459-1.369zm1.207-9.47L5.916 7.11l.918 1.777 3.517-1.816 1.219.36-1.803 3.571a1.998 1.998 0 0 0 .469 2.543l.01.008 3.101 2.891.01.01-1.795 4.847 1.875.696 2.205-5.954-.006-.007-2.17-3.502 1.321-2.64L16.222 12H20.5v-2h-3.223L15.23 6.996l-.006-.004a2 2 0 0 0-1.271-.938l-.004-.004-3.801-1.123zM16.5 2a2 2 0 1 0-.001 4 2 2 0 0 0 .001-4z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Running;
